import { Card, Col, Row } from 'antd';
import React from 'react'

function ElectronicCashPayments() {
  return (
    <Card title="Electronic Cash Payments">
      <Row justify="center">
        <Col><span style={{padding: "2px 16px"}} className='silver-text'>PaySlip</span></Col>
        <Col><span style={{padding: "2px 16px", borderRight: "1px solid silver"}} className='onclick-text'>Download</span></Col>
        <Col><span style={{padding: "2px 16px", borderRight: "1px solid silver"}} className='onclick-text'>Email</span></Col>
        <Col><span style={{padding: "2px 16px"}} className='onclick-text'>Disable For This Tenant</span></Col>
      </Row>
    </Card>
  )
}

export default ElectronicCashPayments;
